<template>
  <v-card :loading="loading">
    <v-card-title class="headline">
      Содание новой сводной
    </v-card-title>

    <v-card-text>
      <v-text-field v-model="postCode"
                    maxlength="6"
                    :counter="6"
                    label="Пост-код"
                    :error-messages="postCodeErrorMessages"
      />
    </v-card-text>

    <v-card-actions>
      <v-btn color="default" text @click="onCloseClicked" :disabled="loading">Закрыть</v-btn>
      <v-spacer/>
      <v-btn color="primary" text dark @click="onCreateClicked" :disabled="loading">Да, создать</v-btn>
    </v-card-actions>

    <v-snackbar v-model="isCreateFailed"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Не удалось создать сводную
    </v-snackbar>

    <v-snackbar v-model="noPostPackagesToGroup"
                :timeout="5000"
                :top="true"
                color="info"
    >
      Нет пост-пакетов для создания сводной
    </v-snackbar>
  </v-card>
</template>

<script>
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import {APP_POST_PACKAGE_GROUP_CREATED} from "@/store/modules/app/actions";
import PostPackageGroupService from '@/services/post.package.group.service'
import {maxLength, minLength, numeric, required} from "vuelidate/lib/validators";
import Mappers from '@/mappers'

export default {
  name: "PostPackageGroupCreate",
  data() {
    return {
      loading: false,
      isCreateFailed: false,
      noPostPackagesToGroup: false,

      postCode: '',
    }
  },
  computed: {
    postCodeErrorMessages() {
      const errors = []

      if (this.$v.postCode.$dirty) {
        !this.$v.postCode.required && errors.push(`Введите индекс`)

        if (this.$v.postCode.required) {
          !this.$v.postCode.numeric && errors.push(`Доступно только цифры`)
          !this.$v.postCode.minLength && errors.push(`Минимум 6 цифр`)
          !this.$v.postCode.maxLength && errors.push(`Максимум 6 цифр`)
        }
      }

      return errors
    }
  },
  validations: {
    postCode: {
      required,
      numeric,
      minLength: minLength(6),
      maxLength: maxLength(6)
    }
  },
  methods: {
    clear() {
      this.postCode = ''
      this.$v.$reset()
    },

    onCloseClicked() {
      this.clear()
      this.$emit('close')
    },
    onCreateClicked() {
      this.postCode = this.postCode.trim()

      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.$store.dispatch(LAYOUT_LOADING_START)

        PostPackageGroupService.create(this.postCode)
            .then(response => {
              if (response.status === 204) {
                this.noPostPackagesToGroup = true
              } else {
                const postPackageGroup = Mappers.mapPostPackageGroup(response.data)

                this.$store.dispatch(APP_POST_PACKAGE_GROUP_CREATED, postPackageGroup)
              }
            })
            .catch(() => {
              this.isUnsetFailed = true
            })
            .finally(() => {
              this.loading = false
              this.$store.dispatch(LAYOUT_LOADING_STOP)

              this.clear()
            });
      }
    }
  }
}
</script>

<style scoped>

</style>